import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.81 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.74 17.69c.36-.4.36-1.04 0-1.45l-5.53-6.2h17.64c.53 0 .95-.47.95-1.04s-.43-1.04-.95-1.04H3.21l5.53-6.2c.36-.41.36-1.04 0-1.45A.9.9 0 0 0 8.06 0c-.26 0-.5.11-.68.31L.27 8.28s-.05.07-.08.12c-.04.06-.09.13-.12.22-.05.13-.07.26-.07.39s.02.26.07.39c.03.09.08.16.14.24 0 .02.05.08.06.1l7.11 7.96c.18.2.42.31.68.31s.5-.11.68-.31Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }